/**
 * @generated SignedSource<<91530785bc8f45bbb710bacf99c0a66b>>
 * @relayHash a201e35c52930069bd3f531056f85a1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2c40c3d1db75173e20637646a4b20589cc3fd8382e93142c654bcc179c8b4dc

import type { ConcreteRequest } from 'relay-runtime';
export type BillingSourceSystem = "CCP" | "HAMS" | "%future added value";
export type PremiumTrialEotQuery$variables = Record<PropertyKey, never>;
export type PremiumTrialEotQuery$data = {
  readonly license: {
    readonly __typename: "License";
    readonly billingSourceSystem: BillingSourceSystem | null;
    readonly trialEndDate: string | null;
  } | null;
};
export type PremiumTrialEotQuery = {
  response: PremiumTrialEotQuery$data;
  variables: PremiumTrialEotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "license",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "billingSourceSystem"
      },
      {
        "kind": "ScalarField",
        "name": "trialEndDate"
      },
      {
        "kind": "ScalarField",
        "name": "__typename"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PremiumTrialEotQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PremiumTrialEotQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a201e35c52930069bd3f531056f85a1e",
    "id": "d2c40c3d1db75173e20637646a4b20589cc3fd8382e93142c654bcc179c8b4dc",
    "metadata": {},
    "name": "PremiumTrialEotQuery",
    "operationKind": "query",
    "text": "query PremiumTrialEotQuery{license{billingSourceSystem,trialEndDate,__typename}}"
  }
};
})();

(node as any).hash = "622a72cff34d40ab317dff21b5897ed5";

export default node;
